import { BaseCard } from './BaseCard'
import { APIClient } from '@/services'
import { RenderItemProps } from '../types'
import { useProfilePrompt } from '../../useProfilePrompt'
import { FeedOptionsSelector } from '../../organisms/OptionsSelector'

export const ActOnClimateCard = ({ item }: RenderItemProps) => {
  const { data: options } = APIClient.Session.useProfileOptions()

  const climateOptions = options?.climate_priority?.slice().reverse() || []

  const prompt = useProfilePrompt(item)

  return (
    <BaseCard prompt={prompt}>
      <FeedOptionsSelector data={climateOptions} {...prompt.form.register('climate_priority')} />
    </BaseCard>
  )
}
